<div class="row custom-row" style="height: auto;" [style]="displayLevel()" *ngIf="bunch.isActive" >
    <div class="row col-sm" (click)="onClick()">
        <div class="col-sm" style="margin-top: auto; margin-bottom: auto;">
            <div class="icons-dropdown" *ngIf="bunch.listChild.length > 0 " [style]="style"></div>
            {{bunch.displayIndex}}
        </div>
        <div class="col-sm " style="margin-top: auto; margin-bottom: auto;">{{bunch.bunch.name}}</div>
        <div class="col-sm" style="text-align: left; line-height: 30px; margin-top: auto; margin-bottom: auto;">{{conCatCameraName()}}</div>
    </div>
    <!-- <div class="col-sm">{{displayCountCam(bunch)}}</div> -->
    <div class="col-sm-2" style="margin-top: auto; margin-bottom: auto;">
        <nav class="action-list">
            <a (click)="editBunch(bunch.bunch)" title="Sửa nhóm">
                <i class="icon icon-edit"></i>
              </a>
            <a (click)="remove(bunch)" title="Xóa nhóm">
                <i class="icon icon-delete"></i>
              </a>
        </nav>
      
    </div>
</div> 